// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__2Iby5","menuItem":"ActionsPopup_menuItem__Auiqb"};